import { LayoutMain } from "@unisearch/theme/layout";
import USAAdmissionDay from "@modules/events/usa_admission_day";

const USAAdmissionDayPage = () => {
  return (
    <LayoutMain
      title="USA Admission Day"
      metaTitle="USA Admission Day"
      metaImage={"/assets/images/events/images/usa-admission-day.webp"}
      metaDescription="Connect with representatives from US universities one to one to discover your ideal pathway for an education abroad! Receive personalized guidance from experts representing institutions like Avila University and Elmhurst University to make your study abroad dreams come true."
      metaKeywords="Event, Fair, Virtual, Virtual fair, University,Admission, Admission Day, USA Admission Day, UniSearch, UniSearch India"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/events/usa-admission-day`}
    >
      <USAAdmissionDay />
    </LayoutMain>
  );
};

export default USAAdmissionDayPage;
